import React from 'react';
import Hero from '../components/Hero';
import ProductGallery from '../components/ProductGallery';
import Features from '../components/Features';
import ProductShowcase from '../components/ProductShowcase';
import About from '../components/About';

const Home = () => {
  return (
    <>
      <Hero />
      <main className="main-content">
        <section className="intro-section">
          <div className="container narrow-container">
            <h2>Medicinal Mushrooms from the Kootenays</h2>
            <p>
              Discover the power of functional mushroom extract powders, carefully wildcrafted and cultivated
              in the pristine forests of British Columbia. Every supplement harnesses concentrated mushroom
              extracts for maximum bioavailability and potency. From Lion's Mane to Reishi, Turkey Tail to Chaga,
              nature's most powerful adaptogens in every capsule.
            </p>
          </div>
        </section>

        <div className="container">
          <ProductGallery />
        </div>

        <div className="container">
          <Features />
        </div>

        <div className="container">
          <ProductShowcase />
        </div>

        <div className="container">
          <About />
        </div>
      </main>
    </>
  );
};

export default Home;
